export default __webpack_public_path__ + "static/media/SignOut_Icon.c5bc8df3.svg";